import { Component, OnInit} from '@angular/core';
import { SYSCONF_SIGLA } from 'src/app.api';
@Component({
	selector: 'app-movimentacao-create',
  	templateUrl: './movimentacaoCreate.component.html',
  	styleUrls: ['./movimentacaoCreate.component.scss']
})

export class MovimentacaoCreateComponent implements OnInit{
	public message:string = '';
	sigla = SYSCONF_SIGLA;
	ngOnInit(){
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		if(!t.permissao.estoque_movimentacao.includes("CRIAR"))
			this.message = 'Você não possui permissão para executar esta ação'
	}
}